import cabinet from './cabinet';

export default {
    cabinet,
};
